import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onBeforeMount } from 'vue';
import { updateConstContentPackage } from '@/utils/logs';
import { sleep } from '@/utils/timer';
import { feConfigUsingPOST } from '@/api/coupon/seller';
import { getUserResourcesGET } from '@/api/merchant/member';
import { getAccountList } from '@/api/user/user';
import { useGlobal } from '@/stores/global'
import { getUrlParam } from '@/utils/url'
import { isAndroid } from './utils/device';

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const globalStore = useGlobal()
const platformSource = getUrlParam('platformSource');

updateConstContentPackage({ source: platformSource, businessLine: '商家平台' });
// try {
//   feConfigUsingPOST().then(({ data }) => {
//     if (data.code === 1) {
//       globalStore.setFeConfig(data.data);
//     }
//   })
// } catch (error) {
//   console.log(error)
// }
const getPermission = async () => {

  try {
      const {data, status, message } = await getUserResourcesGET()
      if (status === 1 && data) {
        globalStore.setUserResources(data);
      }
    } catch (error) {
      console.log(error)
    }
    try {
      const {data, status, message } = await getAccountList()
      if(data) {
          globalStore.setUserInfo(data)
        }
    } catch(err) {
      console.log(err)
    }
}
onBeforeMount(async () => {
  const pathName = window.location.pathname
  if(pathName !== '/squirtle/operate_landing' && pathName !== '/squirtle/tool/transition') {
    await getPermission()
  }
})
if (isAndroid) {
    window.addEventListener(
      'resize',
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      async () => {
        if (document.activeElement!.tagName == 'INPUT') {
            await sleep(2e2);
            document.body.style.height = String(window.screen.availHeight) + 'px';
            // @ts-ignore
            document.activeElement!.scrollIntoViewIfNeeded();
        }
      },
      false
    );
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})